// src/components/Auth/PasswordReset.js
import { sendPasswordResetEmail } from "firebase/auth";
import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import AuthShell, { AuthAlert } from "../../components/AuthShell";
import { auth } from "../../../firebase";

// ActionCodeSettings routes the email action link into the in-app
// "set new password" page (/reset-password) instead of Firebase's generic
// hosted handler. `handleCodeInApp: true` makes Firebase append oobCode to
// `url`. The URL must be an authorized domain in the Firebase Console.
function buildActionCodeSettings() {
  const url = `${window.location.origin}/reset-password`;
  return {
    url,
    handleCodeInApp: true,
  };
}

export default function PasswordReset() {
  const emailRef = useRef();
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      setError("");
      setMessage("");
      await sendPasswordResetEmail(auth, emailRef.current.value, buildActionCodeSettings());
      setMessage("Check your inbox for password reset instructions.");
    } catch (error) {
      setError(`Failed to reset password: ${error.message}`);
      console.error("PASSWORD_RESET_FAILED", error);
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <AuthShell
      eyebrow="Account access"
      title="Reset password"
      subtitle="Enter the email connected to your VdoPage account."
      footer={
        <Link to="/login" className="font-semibold text-[#FF3A20] hover:text-[#e8321c]">
          Back to login
        </Link>
      }
    >
      <form onSubmit={handleSubmit} className="space-y-5">
        {error && <AuthAlert>{error}</AuthAlert>}
        {message && <AuthAlert type="success">{message}</AuthAlert>}

        <div className="field-group">
          <label htmlFor="email" className="field-label">
            Email
          </label>
          <input
            type="email"
            id="email"
            ref={emailRef}
            required
            autoComplete="email"
            className="field-input"
            placeholder="you@example.com"
          />
        </div>

        <button type="submit" className="primary-button w-full" disabled={isSubmitting}>
          {isSubmitting ? "Sending..." : "Send reset link"}
        </button>
      </form>
    </AuthShell>
  );
}
